import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import { Outlet, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyProfileAction } from "../redux/Slices/userSlice";
import { isAuthenticated } from "../services/auth";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Layout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [activeRoute, setActiveRoute] = useState("");
  const [mobileMenu, setMobileMenu] = useState(false);
  const [loading, setLoading] = useState(true);

  const user = useSelector((state) => state?.user?.data);
  const activeOrg = useSelector((state) => state?.org?.active);

  const [searchParams] = useSearchParams();
  const logintoAI = searchParams.get("logintoAI");
  const logintoTrack = searchParams.get("logintoTrack");

  useEffect(() => {
    if (logintoAI !== "true" || !user?.firebase_id) {
      return;
    } else if (
      !["Premium", "Pro"].includes(activeOrg?.Subscriptions?.[0]?.Plan?.
        plan_name)) {
      toast.error("The PandaStack AI is exclusive to Premium and Pro users !! Please upgrade to use this.");
      return;
    }

    const loginUrl = `${process.env.REACT_APP_PANDASTACK_AI_URL}/login?uid=${user.firebase_id}&org_id=${activeOrg?.id}`;

    window.location.assign(loginUrl);
  }, [logintoAI, user?.firebase_id]);

  useEffect(() => {
    if (logintoTrack !== "true" || !user?.firebase_id) {
      return;
    }

    const loginUrl = `${process.env.REACT_APP_PANDATRACK_URL}/auth/signin?uid=${user.firebase_id}&org_id=${activeOrg?.id}`;

    window.location.assign(loginUrl);
  }, [logintoTrack, user?.firebase_id]);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        if (!user) {
          setLoading(true);
        }
        const token = isAuthenticated();
        if (!token) {
          navigate("/");
          return;
        }

        await dispatch(getMyProfileAction({ navigate })).unwrap();
      } catch (error) {
        console.error('Auth check failed:', error);
        navigate("/");
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [dispatch, navigate]);

  useEffect(() => {
    if (!loading && !user) {
      navigate("/");
    }
  }, [user, loading, navigate]);

  // Show loading state while checking auth
  if (loading) {
    return (
      <div className="flex align-items-center justify-content-center" style={{ height: '100vh' }}>
        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
      </div>
    );
  }

  if (!user) {
    return null;
  }

  return (
    <div className="layout-container">
      <ToastContainer />
      <Sidebar setActiveRoute={setActiveRoute} mobileMenu={mobileMenu} setMobileMenu={setMobileMenu} />
      <div className="main-content h-screen flex-1">
        <Topbar activeRoute={activeRoute} setMobileMenu={setMobileMenu} />
        <div className="content-area overflow-auto surface-ground p-2 relative" id="contentArea">
          <Outlet />
        </div>
      </div>
    </div>
  );
}